import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Checkbox } from '../../../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { Icon } from '../../../../../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Tooltip } from '../../../../../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { AccountType } from '../../../../../../api/useAccountsOptionsQuery';
import { FormFields } from '../../AccountForm.meta';
import { Link } from '../../../../../../../../CommonComponents/OPL/Link/Link';

const ToolTipContent = () => {
  return (
    <Text fontSize="small" fontWeight={600} color="white">
      Check this box to bypass MAGI-based limits and allow direct Roth IRA contributions. This also
      enables modeling of nondeductible traditional IRA contributions followed by Roth conversions.
      This setting applies to Roth IRA contributions for each calendar year. For more guidance,
      please see{' '}
      <Link href="https://www.irs.gov/" target="_blank" rel="noopener noreferrer" isExternal>
        Home | Internal Revenue Service
      </Link>{' '}
      articles on IRA{' '}
      <Link
        href="https://www.irs.gov/pub/irs-pdf/p590a.pdf"
        target="_blank"
        rel="noopener noreferrer"
        isExternal
      >
        contributions
      </Link>{' '}
      and{' '}
      <Link
        href="https://www.irs.gov/pub/irs-pdf/p590b.pdf"
        target="_blank"
        rel="noopener noreferrer"
        isExternal
      >
        distributions
      </Link>
      .
    </Text>
  );
};

export const BypassRothIRAIncomeLimits = () => {
  const { watch, register } = useFormContext<FormFields>();

  const ByPassRothIRARegistry = register('bankAccount.IsBypassRothIraIncomeLimits');

  const accountType = watch('bankAccount.AccountType');

  if (accountType !== AccountType.Roth) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center">
      <Checkbox
        {...ByPassRothIRARegistry}
        onChange={evt => {
          ByPassRothIRARegistry.onChange(evt);
        }}
      >
        Bypass Roth IRA income limits
      </Checkbox>

      <Tooltip content={<ToolTipContent />} placement="auto" isInteractive>
        <Icon className="far fa-question-circle" color="neutral.500" fontSize="small" ml="4" />
      </Tooltip>
    </Box>
  );
};
